import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCampoAtuacao'
})
export class FormatCampoAtuacaoPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) {
      return '';
    }

    // Separa o título do restante do texto
    const [title, ...items] = value.split('\n');

    // Formata o título
    let formattedText = `<strong>${title.replace('**', '').trim()}</strong><br>`;

    // Converte os itens da lista em <li>
    const listItems = items
      .filter(item => item.startsWith('*'))
      .map(item => `<li>${item.replace('*', '').trim()}</li>`)
      .join('\n');

    // Adiciona a tag <ul> ao redor dos itens da lista, se houver
    if (listItems) {
      formattedText += `\n<ul>\n${listItems}\n</ul>`;
    }

    return formattedText;
  }

}
